import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "simple-toast__content" }
const _hoisted_2 = { class: "simple-toast__title" }
const _hoisted_3 = { class: "simple-toast__message" }
const _hoisted_4 = { class: "simple-toast__close" }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

type Variant = 'default' | 'failed' | 'success' | 'warning' | 'primary' | 'secondary';

interface SimpleToastText {
  tKey: string;
  tKeyParams: Dictionary<string | boolean | number>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleToast',
  props: {
  iconName: { type: String, required: false },
  message: { type: [String, Object] as PropType<string | SimpleToastText>, required: false },
  showIcon: { type: Boolean, default: true },
  title: { type: [String, Object] as PropType<string | SimpleToastText>, required: false },
  translatedMessage: { type: String, required: false },
  variant: { type: String as PropType<Variant>, default: 'default' },
},
  emits: ["remove"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const titleToShow = computed(() => {
  if (props.title === undefined) {
    return undefined;
  }

  if (typeof props.title === 'string') {
    return t(props.title);
  }

  return props.title.tKeyParams ? t(props.title.tKey, props.title.tKeyParams) : t(props.title.tKey);
});

const messageToShow = computed(() => {
  if (props.message === undefined) {
    return undefined;
  }

  if (typeof props.message === 'string') {
    return t(props.message);
  }

  return props.message.tKeyParams ? t(props.message.tKey, props.message.tKeyParams) : t(props.message.tKey);
});

const icon = computed(() => {
  if (!props.showIcon) {
    return undefined;
  }

  if (props.iconName !== undefined) {
    return props.iconName;
  }

  switch (props.variant) {
    case 'warning':
      return 'info-circle';
    case 'failed':
      return 'danger';
    case 'success':
      return 'tick-circle-bulk';
    case 'default':
    default:
      return 'info-circle-bulk';
  }
});

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["simple-toast", [`simple-toast--${props.variant}`]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["simple-toast__left", { 'simple-toast__left--full-size': __props.showIcon }])
    }, [
      (__props.showIcon && icon.value)
        ? (_openBlock(), _createBlock(_component_ot_icon, {
            key: 0,
            class: "simple-toast__icon",
            name: icon.value
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$slots.title)
          ? _renderSlot(_ctx.$slots, "title", { key: 0 })
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(titleToShow.value), 1)
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$slots.message)
          ? _renderSlot(_ctx.$slots, "message", { key: 0 })
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(__props.translatedMessage || messageToShow.value), 1)
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_x_button, {
        variant: "clear",
        size: "text-like",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('remove')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ot_icon, {
            class: "simple-toast__close-icon",
            name: "close",
            "inherit-fill": true,
            "inherit-stroke": true
          })
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})